var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      attrs: {
        "align-center": "",
        "justify-center": "",
        role: "region",
        "aria-label": "Rapid registration section",
      },
    },
    [
      _c(
        "v-flex",
        { attrs: { xs11: "", sm11: "", md11: "", md4: "", lg4: "" } },
        [
          _c(
            "v-card",
            { attrs: { color: "secondary" } },
            [
              _c(
                "v-app-bar",
                { attrs: { flat: "" } },
                [
                  _c("v-toolbar-title", { staticClass: "text-body-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("components.rapidSignUp.title")) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { attrs: { fluid: "", "grid-list-md": "" } },
                [
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    attrs: {
                      color: "accent",
                      indeterminate: "",
                      "aria-label": "Form processing",
                      "aria-live": "polite",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.filteredErrors, function (errorsGroup, idx) {
                    return _c(
                      "div",
                      {
                        key: "err-grp-" + idx,
                        attrs: { "aria-live": "assertive", role: "status" },
                      },
                      _vm._l(errorsGroup, function (error) {
                        return _c(
                          "v-alert",
                          {
                            key: error.id,
                            attrs: {
                              type: error.type,
                              icon: error.icon,
                              role: "alert",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(error.msg) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: {
                        role: "form",
                        "aria-label": "Rapid sign-up form",
                      },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.validate($event)
                        },
                      },
                    },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|email|min:6|max:255",
                                    expression:
                                      "'required|email|min:6|max:255'",
                                  },
                                ],
                                attrs: {
                                  name: "email",
                                  type: "email",
                                  "prepend-icon": "fal fa-envelope",
                                  color: "accent",
                                  "data-vv-name": "email",
                                  "data-vv-as": "email",
                                  "error-messages": _vm.errors.collect("email"),
                                  label:
                                    _vm.$t(
                                      "components.rapidSignUp.form.email"
                                    ) + " *",
                                  "aria-required": "true",
                                  "aria-invalid": _vm.errors.has("email"),
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  color: "accent",
                                  "aria-checked":
                                    _vm.form.acceptedTermsAndPolicy,
                                  "aria-label":
                                    "Accept Terms & Conditions and Policy",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "components.rapidSignUp.form.acceptTermsAndPolicy"
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "a",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "register-important-link",
                                                              attrs: {
                                                                target:
                                                                  "_blank",
                                                                href: _vm.toTCLink,
                                                                "aria-label":
                                                                  "Read Terms and Conditions (opens in new tab)",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "\n                          Terms & Conditions\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "components.rapidSignUp.form.acceptTermsDialog"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              "\n                    and\n                    "
                                            ),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      return [
                                                        _c(
                                                          "a",
                                                          _vm._g(
                                                            {
                                                              staticClass:
                                                                "register-important-link",
                                                              attrs: {
                                                                target:
                                                                  "_blank",
                                                                href: _vm.toPolicyLink,
                                                                "aria-label":
                                                                  "Read Privacy Policy (opens in new tab)",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "\n                          Policy\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "components.rapidSignUp.form.acceptPolicyDialog"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.form.acceptedTermsAndPolicy,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "acceptedTermsAndPolicy",
                                      $$v
                                    )
                                  },
                                  expression: "form.acceptedTermsAndPolicy",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  color: "accent",
                                  flat: "",
                                  "aria-checked": _vm.form.acceptMarketingNews,
                                  "aria-label": _vm.$t(
                                    "components.rapidSignUp.form.acceptMarketingNews"
                                  ),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.rapidSignUp.form.acceptMarketingNews"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.form.acceptMarketingNews,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "acceptMarketingNews",
                                      $$v
                                    )
                                  },
                                  expression: "form.acceptMarketingNews",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-bottom-sheet",
                            {
                              attrs: {
                                "aria-labelledby": "download-sheet-title",
                                "retain-focus": true,
                                role: "dialog",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _vm.canShowDownloadBtn
                                        ? _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    color: "accent",
                                                    dark: "",
                                                    "aria-label":
                                                      "Open download list",
                                                    "aria-controls":
                                                      "download-sheet",
                                                  },
                                                  on: {
                                                    keydown: function ($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "space",
                                                          32,
                                                          $event.key,
                                                          [" ", "Spacebar"]
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      $event.preventDefault()
                                                      return attrs.click()
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "components.rapidSignUp.buttons.download"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.isSheetOpen,
                                callback: function ($$v) {
                                  _vm.isSheetOpen = $$v
                                },
                                expression: "isSheetOpen",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                {
                                  attrs: { id: "download-sheet", role: "list" },
                                },
                                [
                                  _c(
                                    "v-subheader",
                                    { attrs: { id: "download-sheet-title" } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.rapidSignUp.download.header"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.downloadGames, function (game) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: game.id,
                                        attrs: {
                                          role: "listitem",
                                          tabindex: "0",
                                          link: "",
                                          "aria-label":
                                            "" +
                                            _vm.$t(game.title) +
                                            (game.isNew ? " (New)" : "") +
                                            (game.isRecommend
                                              ? " (Recommended)"
                                              : ""),
                                        },
                                        on: {
                                          keydown: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.goTo(game.link)
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "space",
                                                  32,
                                                  $event.key,
                                                  [" ", "Spacebar"]
                                                )
                                              ) {
                                                return null
                                              }
                                              $event.preventDefault()
                                              return _vm.goTo(game.link)
                                            },
                                          ],
                                          click: function ($event) {
                                            return _vm.goTo(game.link)
                                          },
                                        },
                                      },
                                      [
                                        game.useImageAsBackground
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-list-item-background-image",
                                                style:
                                                  "background-image: url('" +
                                                  game.img +
                                                  "')",
                                                attrs: {
                                                  "aria-label":
                                                    _vm.$t(game.title) +
                                                    " illustration",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-list-item-download-labels",
                                                  },
                                                  [
                                                    game.isNew
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "downloadLabel downloadNew",
                                                          },
                                                          [_vm._v("New")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    game.isRecommend
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "downloadLabel downloadRecommend",
                                                          },
                                                          [_vm._v("Recommend")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    game.isRecommend
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "downloadLabel downloadComingSoon",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Coming Soon"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : [
                                              _c(
                                                "v-list-item-avatar",
                                                { attrs: { size: "25" } },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(_vm._s(game.icon)),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "text-no-wrap" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(game.title)
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "v-list-item-download-labels",
                                                    },
                                                    [
                                                      game.isNew
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "downloadLabel downloadNew",
                                                            },
                                                            [_vm._v("New")]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      game.isRecommend
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "downloadLabel downloadRecommend",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Recommend"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      game.isRecommend
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "downloadLabel downloadComingSoon",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Coming Soon"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                      ],
                                      2
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "sr-only",
                              attrs: { id: "registerHelp" },
                            },
                            [
                              _vm._v(
                                "\n              Submit your email and consent to create your account.\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "accent",
                                type: "submit",
                                disabled: !_vm.form.acceptedTermsAndPolicy,
                                "aria-label": "SignUp",
                                "aria-describedby": "registerHelp",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.rapidSignUp.buttons.register"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }